import React, { useState, useEffect } from "react";

import { CircularProgress, IconButton } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

import { useSpring, animated } from "@react-spring/web";

const ScrollUpButton = () => {
  const [scrolling, setScrolling] = useState(false);
  const [scrollingProgress, setScrollingProgress] = useState(0); // Current scrolling position

  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY >= 1);
      const winScroll = document.documentElement.scrollTop;
      const height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrolled = (winScroll / height) * 100;

      setScrollingProgress(scrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolling]);

  const scrollToTheTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollingButtonAnimation = useSpring({
    from: {
      bottom: "-50px",
      opacity: 0,
    },
    to: {
      bottom: scrolling ? "8px" : "-50px",
      opacity: scrolling ? 1 : 0,
    },
    config: { tension: 170, friction: 26 },
  });

  return (
    <animated.div
      style={{
        position: "fixed",
        right: "8px",
        zIndex: 100,
        ...scrollingButtonAnimation,
      }}>
      <IconButton
        variant="text"
        onClick={scrollToTheTop}
        aria-label="scroll to the top">
        <ArrowUpwardIcon />
        <CircularProgress
          variant="determinate"
          value={scrollingProgress}
          sx={{ position: "absolute" }}
        />
      </IconButton>
    </animated.div>
  );
};

export default ScrollUpButton;
